import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetProjectsQuery } from "../../features/Projects/ProjectsApi";
import {
  useEditTaskMutation,
  useGetTaskQuery
} from "../../features/Task/TaskApi";
import { useGetTeamQuery } from "../../features/TeamMembers/TeamMembersApi";

const EditTask = () => {
  const { data: teamMembers, isLoading: teamLoading } = useGetTeamQuery();
  const { data: projects, isLoading: projectsLoading } = useGetProjectsQuery();
  const [editTask, { isSuccess }] = useEditTaskMutation();
  const navigate = useNavigate();

  const {
    data: tasks,
    isError: taskError,
    isLoading: taskLoading,
  } = useGetTaskQuery();

  const { id: ParamId } = useParams();

  const task = tasks?.find((task) => task.id == ParamId);

  const [taskName, setTaskName] = useState(task?.taskName);
  const [teamMember, setTeamMember] = useState(task?.teamMember.name);
  const [project, setProject] = useState(task?.project.projectName);
  const [deadline, setDeadline] = useState(task?.deadline);

  useEffect(() => {
    setTaskName(task?.taskName);
    setDeadline(task?.deadline);
  }, [task?.taskName, task?.deadline]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/");
    }
  }, [isSuccess, navigate]);

  const updatedTeamMember = teamMembers?.find(
    (member) => member.name === teamMember
  );
  const updatedProject = projects?.find(
    (allProject) => allProject.projectName === project
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      taskName,
      teamMember: updatedTeamMember,
      project: updatedProject,
      deadline,
      status: task?.status,
      id: task.id,
    };

    editTask({ id: ParamId, data });
  };

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Update Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                onChange={(e) => setTaskName(e.target.value)}
                value={taskName}
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                onChange={(e) => setTeamMember(e.target.value)}
                name="teamMember"
                id="lws-teamMember"
                required
              >
                <option value="" hidden>
                  Select Job
                </option>
                {teamLoading ? (
                  <option>Loading...</option>
                ) : (
                  teamMembers.map((member) => (
                    <option key={member.id} selected={member.name === task?.teamMember?.name}>
                      {member.name}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              <select
                onChange={(e) => setProject(e.target.value)}
                id="lws-projectName"
                name="projectName"
                required
              >
                <option value="" hidden>
                  Select Project
                </option>
                {projectsLoading ? (
                  <option>Loading...</option>
                ) : (
                  projects.map((project) => (
                    <option key={project.id}
                      selected={
                        project.projectName === task?.project?.projectName
                      }
                    >
                      {project.projectName}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input
                onChange={(e) => setDeadline(e.target.value)}
                value={deadline}
                type="date"
                name="deadline"
                id="lws-deadline"
                required
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default EditTask;
